export default __webpack_public_path__ + "static/media/canary-checker.f6fcf627.svg";